import { useEffect, useRef } from 'react'
import { useGetSubscriberList } from '../../assets/api/useAdminApi';
import { Box, Typography } from '@mui/material';
import { SkeletonCom } from '../../shared/utils/SkeletonCom';
import CustomDivider from '../../shared/utils/CustomDivider';
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent';

const SubscriberList = () => {

    const {
        data: subscriberData,
        fetchNextPage: fetchNextSubscriberPage,
        hasNextPage: hasNextSubscriberPage,
        isFetchingNextPage: isFetchingNextSubscriberPage,
        isLoading: isSubscriberLoading,
    } = useGetSubscriberList();

    const loadMoreSubscriberRef = useRef();

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && hasNextSubscriberPage) {
                fetchNextSubscriberPage();
            }
        });

        if (loadMoreSubscriberRef.current) {
            observer.observe(loadMoreSubscriberRef.current);
        }

        return () => observer.disconnect();
    }, [hasNextSubscriberPage, fetchNextSubscriberPage]);
    return (
        <NormalContainerWithHeader headerText={"subscriber List"}>

            {
                isSubscriberLoading &&
                <Box sx={{ padding: "1rem" }}>
                    {
                        [...Array(5)].map((_, index) => (
                            <Box key={index}>
                                <SkeletonCom height={50} style={{ borderRadius: "5px" }} />
                                <CustomDivider size={"1rem"} />
                            </Box>

                        ))
                    }
                </Box>

            }

            {
                !isSubscriberLoading && subscriberData?.pages?.map((page,pageIndex) =>
                    page?.data?.map((subscriber,subscriberIndex) => (
                        <Box key={subscriber?.id} sx={{ mb: 3,display:"flex", alignItems:"center", gap:2}}>
                          <Typography>{(pageIndex*10)+subscriberIndex+1}.</Typography>  <Typography>{subscriber?.email}</Typography>
                        </Box>
                    ))
                )
            }

            {isFetchingNextSubscriberPage && <p>Loading more milestone...</p>}

            <div ref={loadMoreSubscriberRef}></div>
        </NormalContainerWithHeader>
    )
}

export default SubscriberList
